import React, {useEffect, useState} from 'react';
import {Helmet} from "react-helmet"
import Menu from "../components/Menu";

const StaticPage = ({description_file, title, meta, }) => {
    let [ description, setDescription ] = useState('');
    const getData=()=>{
        fetch(process.env.PUBLIC_URL + `/pages/${description_file}.txt`
            ,{
                headers : {
                    'Content-Type': 'application/text',
                    'Accept': 'application/text'
                }
            }
        )
            .then(function(response){
                return response.text()
            })
            .then(function(text) {
                setDescription(text);
            });
    };
    useEffect(()=>{
        getData();
    },[description_file]);
    return <React.Fragment>
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={meta}/>
        </Helmet>
        <div className="row justify-content-between content">
            <div className="col-lg-8 col-xs-12 col-sm-12">
                <div dangerouslySetInnerHTML={{__html: description}} />
            </div>
            <div className="col-lg-4 col-xs-12 col-sm-12">
                <Menu {...{parent: {className: "main-menu"}, short: true}}/>
            </div>
        </div>
    </React.Fragment>
};

export default StaticPage;